import { render, staticRenderFns } from "./ProductionDashboard.vue?vue&type=template&id=a31cc91e&"
import script from "./ProductionDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports